// extracted by mini-css-extract-plugin
module.exports = {"root":"Status_root__2TGjx","approved":"Status_approved__3gkRa","rejected":"Status_rejected__pwgf9","expired":"Status_expired__2p43I","label":"Status_label__y8LCP"};